<template>
  <div class="flex justify-end">
    <!-- <div class="filterBtn justify-end px-2 py-4 text-NotoSansLight hidden md:flex">
      <div class="publishDate textColorgray cursor-pointer text-sm" :class="{ textColorBlack: sort.type === 'published_at' }"
        @click="updatedSort('published_at')">出版日期由新→舊</div>
      <span class="mx-2 text-sm">|</span>
      <div class="priceHigh textColorgray cursor-pointer text-sm" :class="{ textColorBlack: sort.type === 'asc' }"
        @click="updatedSort('asc')">價格由低→高</div>
      <span class="mx-2 text-sm">|</span>
      <div class="priceDown textColorgray cursor-pointer text-sm" :class="{ textColorBlack: sort.type === 'desc' }"
        @click="updatedSort('desc')">價格由高→低</div>
    </div> -->
    <div class="mt-3 mb-4 flex items-center justify-end">
      <div class="relative">
        <select class="block appearance-none w-full border border-gray-400 textColorDarkBlack py-2 px-4 pr-8 rounded leading-tight focus:outline-none bg-white focus:border-gray-500 text-sm" id="filterBtn"
          @change="updatedSort($event.target.value)">
          <option value="published_at">出版日期由新→舊</option>
          <option value="published_at_old">出版日期由舊→新</option>
          <option value="price_up" v-if="$route.params.category !== 'recent'">價格由低→高</option>
          <option value="price_down" v-if="$route.params.category !== 'recent'">價格由高→低</option>
        </select>
        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 textColorDarkBlack">
          <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Sort',
  data () {
    return {
    }
  },
  props: {
    sort: {
      type: Object
    }
  },
  methods: {
    updatedSort (val) {
      let self = this
      let sortData = {}
      switch (val) {
        case 'published_at':
          // 出版日期由新→舊
          sortData.sort = 'published_at'
          sortData.sortBy = 'desc'
          break
        case 'published_at_old':
          // 出版日期由舊→新
          sortData.sort = 'published_at'
          sortData.sortBy = 'asc'
          break
        case 'price_up':
          // 價格由低→高
          sortData.sort = 'pricing'
          sortData.sortBy = 'asc'
          break
        case 'price_down':
          // 價格由高→低
          sortData.sort = 'pricing'
          sortData.sortBy = 'desc'
          break
      }

      self.$emit('updatedSort', sortData)
    }
  }
}
</script>

<style lang="scss" scoped>
  .dropdown {
    .dropdown-content {
      top: -999px;
      opacity: 0;
      position: absolute;
      background-color: #ffffff;
      width: 12rem;
      z-index: 10;
      transition: opacity 0.2s ease;
      transform: translateX(-50%);
      left: -50%;
      .item {
        max-width: 150px;
        margin: auto;
        &:hover {
          a {
            // text-decoration: underline;
            transition: 0s;
            opacity: 0.7;
          }
        }
      }
      a {
        text-decoration: none;
        display: block;
        font-weight: 400;
        color: #898989;
        transition: .3s;
      }
      .font-awesome {
        opacity: 0;
      }
      .opacity1 {
        opacity: 1;
      }
    }
    &:hover {
      .dropdown-content {
        opacity: 1;
        top: 80% !important;
      }
    }
  }

</style>
